import { div } from 'framer-motion/client';
import React, { useState, useRef, useEffect } from 'react';
import { IoSend } from 'react-icons/io5'; // React Icons kütüphanesinden gönderme simgesi

const ChatBot = () => {
  // Mesajları tutacak state
  const [messages, setMessages] = useState([]);
  // Kullanıcı girdisini tutacak state
  const [input, setInput] = useState('');
  // Yükleniyor durumu için state
  const [isLoading, setIsLoading] = useState(false);
  // Mesaj listesinin referansı (otomatik kaydırma için)
  const messagesEndRef = useRef(null);
  // Mesaj listesi container referansı
  const messagesContainerRef = useRef(null);
  
  // Google Cloud Run üzerindeki Rasa API URL'si
  const RASA_API_URL = 'https://rasa-service-296705943739.us-central1.run.app/webhooks/rest/webhook';

  // Sayfa yüklendiğinde karşılama mesajını göster
  useEffect(() => {
    if (messages.length === 0) {
      setMessages([
        {
          sender: 'bot',
          text: 'Would you like to get information about ISO 50001?'
        }
      ]);
    }
  }, []);

  // Mesajlar değiştiğinde otomatik olarak en alta kaydır
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // En alta kaydırma fonksiyonu
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Mesaj gönderme fonksiyonu
  const sendMessage = async () => {
    if (input.trim() === '' || isLoading) return;

    // Kullanıcı mesajını ekle
    const userMessage = { sender: 'user', text: input };
    setMessages(prevMessages => [...prevMessages, userMessage]);
    
    // Input'u temizle ve yükleniyor durumunu ayarla
    setInput('');
    setIsLoading(true);

    try {
      // Google Cloud Run üzerindeki Rasa API'ye istek gönder
      const response = await fetch(RASA_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          sender: 'user',
          message: input
        })
      });

      const data = await response.json();

      // Bot yanıtlarını ekle
      if (data.length === 0) {
        setMessages(prevMessages => [
          ...prevMessages,
          { sender: 'bot', text: 'Sorry, I can\'t answer this question.' }
        ]);
      } else {
        // Tüm bot yanıtlarını ekle
        data.forEach(message => {
          if (message.text) {
            setMessages(prevMessages => [
              ...prevMessages,
              { sender: 'bot', text: message.text }
            ]);
          }
        });
      }
    } catch (error) {
      console.error('Error:', error);
      setMessages(prevMessages => [
        ...prevMessages,
        { sender: 'bot', text: 'An error occurred. Please try again.' }
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='flex absolute w-full h-full bg-[#B7B1F2] py-10'>
        <div className="flex flex-col md:max-w-[80%] w-[90%] bg-[#FFDCCC] border-4 border-black rounded-xl shadow-lg md:p-10 p-3 mx-auto overflow-hidden">
        {/* Header */}
        <div className="bg-purple-500 text-white p-4 text-center border-4 border-black rounded-t-xl">
            <h2 className="text-xl font-semibold">ISO 50001 İnformation Robot</h2>
        </div>
        
        {/* Messages */}
        <div 
            ref={messagesContainerRef}
            className="flex-1 overflow-y-auto p-4 bg-gray-100 border-4 border-black flex flex-col"
        >
            {messages.map((message, index) => (
            <div 
                key={index} 
                className={`max-w-[70%] p-3 mb-2 rounded-xl border-2 border-black ${
                message.sender === 'user' 
                    ? 'bg-green-100 self-end rounded-br-none' 
                    : 'bg-white self-start rounded-bl-none shadow'
                }`}
            >
                {/* Burada değişiklik yapılacak */}
                {message.text.split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                    {line}
                    {i < message.text.split('\n').length - 1 && <br />}
                    </React.Fragment>
                ))}
            </div>
            ))}
            
            {/* Yükleniyor göstergesi */}
            {isLoading && (
            <div className="self-start bg-white border-2 border-black p-3 rounded-xl rounded-bl-none shadow flex items-center">
                <div className="flex space-x-1">
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                </div>
            </div>
            )}
            
            <div ref={messagesEndRef} />
        </div>
        
        {/* Input */}
        <div className="flex p-4 bg-white border-4 border-black rounded-b-xl">
            <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                    sendMessage();
                    }
                }}
                placeholder="Write a message..."
                className="flex-1 px-4 py-2 border-2 border-black rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <button 
            onClick={sendMessage}
            disabled={isLoading || input.trim() === ''}
            className={`ml-2 rounded-full w-10 h-10 flex items-center justify-center transition-colors ${
                isLoading || input.trim() === '' 
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
                : 'bg-purple-500 text-white hover:bg-purple-700'
            }`}
            >
            <IoSend className="w-5 h-5" />
            </button>
        </div>
        </div>
    </div>
  );
};

export default ChatBot;